// catalog-edition-helpers.ts — fonctions PURES partagées de l'édition catalogue.
// Extraites du monolithe `catalog-edition-screen.tsx` (2222 lignes) pour être partagées entre
// l'écran de composition et les sous-composants (matrice, grille, profils) au fil du découpage.
// Aucun effet de bord hors saveCsv (déclenchement navigateur explicite).

// -----------------------------------------------------------------------------
// R-2 — conversion d'affichage de la corrélation (contrat 0-1 ↔ IHM 0-100 %).
// -----------------------------------------------------------------------------
// Le contrat reste 0-1 ; ces fonctions ne servent QUE l'IHM. La division/multiplication par 100
// peut introduire une erreur flottante (0.6 × 100 = 60.00000000000001) : on borne l'affichage à
// l'entier le plus proche (DBU : saisie entière, step=1) et la conversion inverse à 3 décimales.

/** Convertit un poids de contrat (0-1) en pourcentage d'affichage entier (0-100). */
export function correlationWeightToPercent(weight: number): number {
  return Math.round(weight * 100);
}

/** Convertit une saisie en pourcentage (0-100) vers un poids de contrat (0-1). */
export function correlationPercentToWeight(percent: number): number {
  return Math.round(percent) / 100;
}

const EDGE_KEY_SEP = '::';

/** Clé d'index orienté d'une arête (from → to). */
export function edgeKey(from: string, to: string): string {
  return `${from}${EDGE_KEY_SEP}${to}`;
}

/** Seuil « corrélation majeure » (DBU §2.4 l.908 : « corrélations majeures (>20 %) »). */
export const MAJOR_CORRELATION_PERCENT = 20;

/**
 * Classe de fond de la carte de chaleur, bucketée par pourcentage (l.967). Classes LITÉRALES
 * (JIT Tailwind) ; alpha borné à /40 pour préserver le contraste du % textuel (WCAG 2.1 AA —
 * la couleur n'est jamais seule porteuse, le % reste toujours affiché).
 */
export function heatmapClass(percent: number): string {
  if (percent <= 0) {
    return '';
  }
  if (percent <= 25) {
    return 'bg-primary/10';
  }
  if (percent <= 50) {
    return 'bg-primary/20';
  }
  if (percent <= 75) {
    return 'bg-primary/30';
  }
  return 'bg-primary/40';
}

/** Déclenche l'enregistrement navigateur d'un contenu CSV sous `filename`. */
export function saveCsv(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
